import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";

export const usePrint = (callbackFn) => {
  const isDev = process.env.NODE_ENV !== "production";

  const contentRef = useRef(null);
  const [isPrinting, setIsPrinting] = useState(false);

  const reactToPrintContent = () => {
    return contentRef.current;
  };

  const handlePrintFn = useReactToPrint({
    preserveAfterPrint: isDev,
    pageStyle: `
      @media print {
        body {
          -webkit-print-color-adjust: exact;
          print-color-adjust: exact;
          font-weight: 400;
        }
        html, body {
          height: initial !important;
          overflow: initial !important;
          font-weight: 400;
        }
      }
    `,
    onBeforePrint: async () => {
      setIsPrinting(true);
    },
    onAfterPrint: () => {
      setIsPrinting(false);
      callbackFn();
    }
  });

  const handlePrint = () => handlePrintFn(reactToPrintContent);

  return { contentRef, isPrinting, setIsPrinting, reactToPrintContent, handlePrint };
};
